// extracted by mini-css-extract-plugin
export default {"deedsWrap":"deedsWrap___JMlv0","itemWrap":"itemWrap___cmKts","label":"label___Ac8v6","text":"text___AixUS"};